import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { CardView } from 'src/app/interfaces/cardview';

@Component({
    selector: 'dic-form',
    templateUrl: './dictionary-form.component.html',
    styleUrls: ['./dictionary-form.component.scss'],
    standalone: false
})
export class DictionaryFormComponent implements OnInit {

  constructor() { }

  eventsSubject: Subject<string> = new Subject<string>();
  parentRow:CardView = {};
  condition:string = '0=0'
  
  ngOnInit(): void {
  }
}
